import type { LeadFlowChoiceArrangement } from "../types";

const CHOICE_ARRANGEMENT_CLASSES: Record<LeadFlowChoiceArrangement, string> = {
  cards: "flex flex-col gap-3",
  list: "flex w-full min-w-0 flex-col gap-4",
  "tile-grid": "grid grid-cols-2 gap-3",
};

export { CHOICE_ARRANGEMENT_CLASSES };
